import React, { useState } from 'react';

import useAdGroups from '../../hooks/useAdGroups';
import AutocompleteArray, { AutocompleteArrayProps } from './AutocompleteArray';

interface AdGroupSelectorProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
> extends Omit<AutocompleteArrayProps<T | string, Multiple, DisableClearable, FreeSolo>, 'options'> {
  lineItemId: number;
}

function AdGroupSelector<
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>({ lineItemId, ...rest }: AdGroupSelectorProps<T, Multiple, DisableClearable, FreeSolo>) {
  const [open, setOpen] = useState(false);
  const { data, fetchStatus } = useAdGroups(lineItemId, open);

  const options = data?.collection?.map((item) => ({ label: item.name, value: item.id })) || [];

  const jsxProps = {
    loading: fetchStatus === 'fetching',
    options,
    ...rest,
    open,
    onOpen: () => {
      setOpen(true);
    },
    onClose: () => {
      setOpen(false);
    },
  };

  return (
    <AutocompleteArray
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...jsxProps}
      normalizeOutput={(outputArray) => outputArray.map((item) => item.value)}
      normalizeInput={(inputArray) => options.filter((item) => inputArray?.includes(item.value))}
    />
  );
}

export default AdGroupSelector;
